import { Dispatch } from "redux";
import { SidebarAction, SidebarActionTypes } from "../types/sidebar";

export const toggleSidebar = () => {
  return async (dispatch: Dispatch<SidebarAction>) => {
    dispatch({ type: SidebarActionTypes.TOGGLE_SIDEBAR });
  };
};
